import styled from "styled-components";

export default function SectionTabBar({
  rows = 0,
  buttonsPerRow = 0,
  buttonWidth = false,
  children,
}) {
  const numberOfButtons = children.length;

  if (!buttonWidth) {
    if (rows > 0 && buttonsPerRow === 0)
      buttonsPerRow = Math.ceil(numberOfButtons / rows);

    if (buttonsPerRow === 0) buttonsPerRow = 3;

    buttonWidth = `calc((100% - ${(buttonsPerRow - 1) * 4}px) / ${buttonsPerRow})`;
  }

  return (
    <Wrapper style={{ "--tabButtonWidth": buttonWidth }}>{children}</Wrapper>
  );
}
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  gap: 4px;
  justify-content: center;
  align-items: stretch;
`;
export const SectionTabBarWrapper = styled.div`
  margin: 4px 12px;
  &:last-child {
    margin-bottom: 0;
  }
`;
